<template>
  <SelectBox
    @open="getItems"
    @search="setSearch"
    @option:selected="downloadFile"
    :options="items"
    :validActivated="validActivated"
    :label="label"
    :noLabel="noLabel"
    v-model="selectedItem"
    :disabled="disabled"
    :searchable="true"
    :clearable="clearable"
  >
    <template #selected-option="{ item }">
      <i class="u-color-danger icofont-file-pdf"></i> {{ item.title }}
    </template>
    <template #option="{ item }">
      <i class="u-color-danger icofont-file-pdf"></i> {{ item.title }}
    </template>
    <template #not-auth v-if="$status.projectFileLog === 'NOT_AUTHORIZED'">
      <not-auth></not-auth>
    </template>
  </SelectBox>
</template>

<script>
import Requests from "@/services/Requests";
import SelectBox from "../Base/Inputs/SelectBox.vue";
export default {
  components: {
    SelectBox,
  },
  data() {
    return {
      items: [],
      search: "",
      selectedItem: null,
    };
  },
  props: {
    value: {
      default: null,
    },
    clearable: {
      default: false,
      type: Boolean,
    },
    noLabel: {
      default: false,
      type: Boolean,
    },
    label: {
      type: String,
      required: true,
    },
    validActivated: {
      default: false,
      type: Boolean,
    },
    query: {
      default: () => ({}),
      type: Object,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    path: {
      type: String,
      required: true,
    },
    project: {
      type: Object,
    },
  },
  computed: {
    filteredItems() {
      return this.items.filter((item) => item.title.includes(this.search));
    },
  },
  methods: {
    setSearch(search, loading) {
      this.search = search;
      loading(false);
    },
    /**
     * Makes a request to get all items that match the given search query.
     *
     * @param {string} search - search query to send to the API
     * @param {function} loading - function to call when the request is sending or done. Pass true to indicate sending, false to indicate done.
     */
    async getItems(search, loading) {
      if (this.items.length > 0) return loading(false);
      if (this.project) {
        await this.getProjectFiles(loading);
        return;
      }
      loading(true);
      const response = await Requests.ProjectFileLog.GetDirectoriesAndFiles({
        query: { path: this.path },
      });
      this.$status.projectFileLog = response.message;
      if (response.message === "OK") {
        this.items = response.data.filter((item) =>
          item.title.includes(".pdf")
        );
      } else {
        this.items = [];
      }
      loading(false);
    },
    async downloadFile(file) {
      this.$store.dispatch("SET_ACTION_MODAL", {
        isLoading: true,
        status: true,
        message: this.$t("common.downloading"),
        duration: 20 * 60 * 1000,
      });
      const response = await Requests.ProjectFileLog.DownloadFile({
        query: { fileName: file.title, path: this.path },
      });
      const url = response;
      //  window.open(url, "_blank");
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.setAttribute("download", file.title);
      document.body.appendChild(link);
      link.click();
      this.$store.dispatch("SET_ACTION_MODAL", {
        isLoading: false,
        status: false,
      });
    },
    async getProjectFiles(loading) {
      const response = await Requests.ProjectFileLog.GetAll({
        query: {
          projectId: this.project.id,
          isActive: true,
        },
      });
      this.items = response.data.items
        .map((ite) => ({
          ...ite,
          title: ite.filename,
        }))
        .sort((a, b) => a.projectTag.id - b.projectTag.id);
      loading(false);
    },
  },
};
</script>

<style></style>
